import gql from 'graphql-tag';
import { find, get } from 'lodash';
import { graphql } from 'react-apollo';
import logToDataDog from '../config/logToDataDog';

const GET_PROVIDER_LOCATIONS_PHONES = gql`
    query getProviderLocationsPhones(
        $providerId: String
        $directoryId: String
    ) {
        provider(id: $providerId, directoryId: $directoryId) {
            id
            locations {
                id
                monolithId
                phone
                phoneExt
            }
        }
    }
`;

export const mapProviderLocationsPhones = ({ ownProps, data }) => {
    if (data.loading) return { providerLoading: true };
    if (data.error) return { hasErrors: true };

    if (!data.provider) {
        logToDataDog({
            name: 'bwa.gql.error',
            type: 'increment',
            value: 1,
            tags: [`noProvider`],
        });
        return { hasErrors: true };
    }
    const providerLocation = find(
        data.provider.locations,
        (location) => location.monolithId === ownProps.locationId
    );
    const phoneExt = get(providerLocation, 'phoneExt', '');
    const phone = get(providerLocation, 'phone', '');
    const providerLocationPhone =
        phoneExt.length > 0 ? `${phone} ${phoneExt}` : phone;

    return {
        providerLocationPhone,
    };
};

export const withProviderLocationsPhones = graphql(
    GET_PROVIDER_LOCATIONS_PHONES,
    {
        skip: (ownProps) => {
            return !ownProps.providerId;
        },
        options: (ownProps) => ({
            variables: {
                providerId: ownProps.providerId,
                directoryId: '-1',
            },
        }),
        props: mapProviderLocationsPhones,
    }
);

export default withProviderLocationsPhones;
